mutation UpsertApplicationFromApplicationConsole(
    $domain: String!
    $application: ApplicationInput!
) {
    upsertApplication(
        domain: $domain
        application: $application
    ) {
        id
        domain

        name
        about {
            language
            text
        }

        country

        brandIDs
        colors {
            accent {
                ...UpsertedApplicationColor
            }
            primary {
                ...UpsertedApplicationColor
            }
            secondary {
                ...UpsertedApplicationColor
            }
            tertiary {
                ...UpsertedApplicationColor
            }
        }
        favicon
        logo
        coverImage

        instanceSpecification {
            ...UpsertedSpecificationConfiguration
        }
        typeSpecification {
            ...UpsertedSpecificationConfiguration
        }

        features
    }
}

fragment UpsertedApplicationColor on ApplicationColor {
    contrastText
    dark
    light
    main
}

fragment UpsertedSpecificationConfiguration on SpecificationConfiguration {
    bimClassIDs
    customSpecification
    realSpecification
    rootCategoryID
}
